import React from 'react';
import { useLoading } from '../context/LoadingContext';

export default function LoadingOverlay() {
  const { isLoading } = useLoading();

  if (!isLoading) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-ink/30 backdrop-blur-[1px]">
      <div className="flex flex-col items-center gap-3 bg-card rounded-2xl px-8 py-6 shadow-lg">
        <div className="h-8 w-8 rounded-full border-4 border-border border-t-gold animate-spin" />
        <span className="text-sm font-medium text-muted">Loading…</span>
      </div>
    </div>
  );
}
